export default function menuAdd_getProjectTemplates(templates: any[], onAddSubproject: func, onAddFromLibrary: func) {
    const templatesOptions: any = []
    _.map(templates, template=>{
        if (template.typeId === 'workfolder') return
        templatesOptions.push({
            icon    : template.icon,
            label   : template.title,
            onClick : ()=>onAddSubproject(template.id)
        })
    })
    templatesOptions.push({type: 'separator'})
    templatesOptions.push({
        icon    : 'i5-templates',
        label   : 'Templates library',
        onClick : ()=>onAddFromLibrary()
    })

    return templatesOptions
}